export function priceLabel(price, unit) {
  const p = `₹${price}`;
  if (unit === "hour") return `${p} / hr`;
  if (unit === "day") return `${p} / day`;
  return p;
}

export function unitSuffix(unit) {
  if (unit === "hour") return "/ hr";
  if (unit === "day") return "/ day";
  return "";
}
